import * as React from "react";
import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { SecurityAppSecurityEvents } from "@graylog/enterprise-api";
import { SystemCatalog } from "@graylog/server-api";
import SuggestionsList from "components/common/EntityFilters/FilterConfiguration/SuggestionsList";
const DEFAULT_SEARCH_PARAMS = {
  query: "",
  pageSize: 10,
  page: 1
};
const renderAssociatedAssetTitle = (_value, title) => _value === null ? /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("i", null, "none")) : /* @__PURE__ */ React.createElement("span", null, title);
const fetchAssociatedAssets = () => SecurityAppSecurityEvents.getFilterOptions({
  fields: ["associated_assets"],
  timerange: 30 * 86400
}).then((resp) => {
  const assets = resp.associated_assets;
  return SystemCatalog.getTitles({
    entities: assets.flatMap((asset) => [
      {
        id: asset,
        type: "assets",
        identifier_type: void 0,
        display_template: void 0,
        identifier_field: void 0,
        display_fields: void 0
      }
    ])
  });
}).then((resp) => resp.entities.map((entry) => ({ id: entry.id, value: entry.title })));
const AssociatedAssetsFilter = ({ attribute, allActiveFilters, filter, onSubmit }) => {
  const [filterQuery, setSearchParams] = useState(DEFAULT_SEARCH_PARAMS);
  const { data: _suggestions, isInitialLoading } = useQuery({
    queryKey: ["security_events", "associated_assets"],
    queryFn: fetchAssociatedAssets
  });
  const suggestions = useMemo(
    () => _suggestions ? [
      { id: null, value: "no asset" },
      ..._suggestions.filter((suggestion) => suggestion.value.toLowerCase().includes(filterQuery.query))
    ] : _suggestions,
    [_suggestions, filterQuery]
  );
  return /* @__PURE__ */ React.createElement(
    SuggestionsList,
    {
      allActiveFilters,
      attribute,
      multiSelect: !filter,
      filterValueRenderer: renderAssociatedAssetTitle,
      onSubmit,
      suggestions,
      isLoading: isInitialLoading,
      total: suggestions == null ? void 0 : suggestions.length,
      page: 1,
      pageSize: suggestions == null ? void 0 : suggestions.length,
      setSearchParams
    }
  );
};
export default AssociatedAssetsFilter;
